export const KEY_CODES = {
    ENTER: 13,
    ESC: 27
};
